import { setCookie } from './common';

/**
 * Signs in a just-verified account. It stays on `signup` until the paywall
 * starts its trial, which then runs /onboard-user.
 */
export default function startVerifiedSession({ token, status }) {
  setCookie(process.env.REACT_APP_AI_TOKEN_COOKIE, token);
  setCookie(process.env.REACT_APP_AI_STATUS_COOKIE, status);
  localStorage.removeItem('email');
}
